<div class="initials-avatar" *ngIf="!avatarImg || avatarImg === ''">
  {{getAvatarInitials()}}
</div>
<img src="{{avatarImg}}" *ngIf="avatarImg" [ngStyle]='imgStyles'/>